import Router from 'vue-router'

const routes = [
  {
    path: "/",
    name: "LiveList",
    component: () => import("../views/liveList"),
    meta: {
      business: '直播',
      pageName: '哆啦dola直播',
      title: '哆啦dola直播'
    }
  },
  {
    path: "/previewDetails",
    name: "PreviewDetails",
    component: () => import("../views/previewDetails"),
    meta: {
      business: '直播',
      pageName: '直播预告',
      title: '直播预告'
    }
  },
  {
    path: "/liveDetails",
    name: "LiveDetails",
    component: () => import("../views/liveDetails"),
    meta: {
      business: '直播',
      pageName: '直播详情',
      title: '直播详情'
    }
  },
  {
    path: "/replayList",
    name: "ReplayList",
    component: () => import("../views/replayList"),
    meta: {
      business: '直播',
      pageName: '精彩回放',
      title: '精彩回放'
    }
  },
  {
    path: "/protocol",
    name: "Protocol",
    component: () => import("../views/protocol/rechargeProtocal"),
    meta: {
      business: '直播',
      pageName: '用户充值协议',
      title: '壹心理用户充值协议'
    }
  },
  {
    path: "/yxlCoinInstructions",
    name: "YxlCoinInstructions",
    component: () => import("../views/protocol/yxlCoinInstructions"),
    meta: {
      business: '直播',
      pageName: '鲸币说明',
      title: '鲸币说明'
    }
  },
  {
    path: "/fundsManage",
    name: "FundsManage",
    component: () => import("../views/fundsManage"),
    meta: {
      business: '直播',
      pageName: '鲸鱼账户',
      title: '鲸鱼账户'
    }
  },
  {
    path: "/income",
    name: "income",
    component: () => import("../views/fundsManage/incomeRecord"),
    meta: {
      business: '直播',
      pageName: '鲸币收入',
      title: '鲸币收入'
    }
  },
  {
    path: "/consumption",
    name: "Consumption",
    component: () => import("../views/fundsManage/consumptionRecord"),
    meta: {
      business: '直播',
      pageName: '消费记录',
      title: '消费记录'
    }
  },
  {
    path: "/recharge",
    name: "Recharge",
    component: () => import("../views/fundsManage/rechargeRecord"),
    meta: {
      business: '直播',
      pageName: '充值记录',
      title: '充值记录'
    }
  },
];

export const asyncRouterMap = [
]

export default new Router({
  routes: routes
})
